import React, { FC, useEffect, useState } from "react";
import { IStyle, mergeStyles, mergeStyleSets } from "@fluentui/react";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import {
  Nomination,
  ActivityLog,
  ApiCallModel,
  LineHandling,
  TruckNomination,
} from "../../../models";
import { NominationDetailsPane } from "./NominationDetailsPane";
import SofIcon from "../../common/Icons";
import NominationForm from "./NominationForm";
import { pushNotification } from "../../../api/pushNotification";
import RemarksPane from "../RemarksPane";
import { MODALITY } from "../../../models/WorkPacket";
import { toNominationNo } from "../../../services/Helper";

type Props = {
  lineHandlingStatus: number;
  isLineHandlingRejected: boolean;
  nomination: TruckNomination | null;
  isEditActivityAllowed: boolean;
  isAddCommentAllowed: boolean;
  isDeleteCommentAllowed: boolean;
  isOffline: boolean;
  isApproved: boolean;
  onNominationEditStart(): void;
  onNominationEditEnd(): void;
  onNominationEdit(nom: TruckNomination): void;
  activityLog: ApiCallModel<ActivityLog[]> | null;
  selTransferType: string;
  isVerifyInformationModal: boolean;
  isApproveRejectionAllowed: boolean;
  setTruckNomination: (nom: TruckNomination) => void;
};
const buttonBase = mergeStyles({
  padding: "9px 10px",
  fontSize: 16,
  fontWeight: 500,
  height: 42,
  border: "none",
  selectors: {
    [":active"]: {
      backgroundColor: "#008cc0",
    },
  },
} as IStyle);
const classes = mergeStyleSets({
  buttonRow: {
    border: "1px solid #E2E6E8",
    alignItems: "center",
    display: "flex",
    padding: 10,
    marginTop: "16px",
  },
  buttonRowFiller: {
    flex: "grow",
    flexGrow: 1,
  },
  button: [
    buttonBase,
    {
      backgroundColor: "#F2F4F6",
      color: "#4C4C4C",
      display: "flex",
      alignItems: "center",
      padding: "9px 15px",
    },
  ],
  dropdown: {
      color: "#202323",
    fontWeight: 400,
    fontSize: 16,
    marginRight: "auto",
  },
});

enum NomView {
  View = 0,
  Edit = 1,
  Comments = 2,
  Rejections = 3,
}

const NominationPanel: FC<Props> = (props: Props) => {
  const history = useHistory();
  const [lineHandlingNo, setLineHandlingNo] = useState("");
  const [nominationNo, setNominationNo] = useState("");
  const [view, setView] = useState<NomView>(NomView.View);
  const [modality, setModality] = useState<MODALITY>("TRUCK");
  const [isNominationEditable, setIsNominationEditable] =
    useState<boolean>(true);

  useEffect(() => {
    if (props.nomination) {
      setView(NomView.View);
      // setLineHandlingNo(props.nomination.lineHandlingNo);
      setNominationNo(props.nomination.nominationNo);

      // const { nominationNo } = props.nomination;
      // const nomNo = nominationNo.substr(nominationNo.length - 6);
      // if (nomNo) setShortNominationNo(nomNo);
    }
  }, [props.nomination]);

  useEffect(() => {
    if (props.nomination) {
      const { nominationNo } = props.nomination;

      // if (props.activityLog && props.activityLog.result) {
      //   const transferStarted = props.activityLog.result.find(
      //     f =>
      //       f.nominationNo === nominationNo &&
      //       f.description === "Transfer in progress"
      //   );

      //   if (transferStarted) {
      //     setIsNominationEditable(false);
      //   }
      // }
      if (props.lineHandlingStatus === 4 || props.nomination.status >= 2) {
        setIsNominationEditable(false);
      }
    }
  });

  useEffect(() => {
    if (view === NomView.Edit) {
      props.onNominationEditStart();
    }
  }, [view]);

  useEffect(() => {
    pushNotification.connection.on("NominationUpdated", (message) => {
      var result = message as TruckNomination;
      if (
        props.nomination &&
        result.nominationNo === props.nomination.nominationNo
      ) {
        setView(NomView.View);
        props.onNominationEdit(result);
        props.onNominationEditEnd();
      }
    });
  }, [props.nomination]);

  useEffect(() => {
    if (history.location.pathname.indexOf("marine") >= 0) {
      setModality("MARINE");
    } else if (history.location.pathname.indexOf("truck") >= 0) {
      setModality("TRUCK");
    } else if (history.location.pathname.indexOf("rail") >= 0) {
      setModality("RAIL");
    }
  }, []);

  const onPreview = () => {
    if (nominationNo) {
      var params = "";
      if (nominationNo) {
        params = "?nomination=" + nominationNo;
      }
      history.push(`/truck/${nominationNo}/sof/${params}`);
    }
  };

  const Label = () => {
    const { rejectionStatus, modality } = props?.nomination as any;

    switch (modality) {
      case 1:
        switch (rejectionStatus) {
          case 2:
            return "Verify Rejection";
        }
        break;
      case 2:
        switch (rejectionStatus) {
          case 2:
            return "Confirm Repair";
          case 3:
            return "Verify Repair Completed";
        }
        break;
    }
  };

  return (
    <>
      {/* <div>
        <dt>Nomination</dt>
      </div> */}
      {((props?.nomination &&
        props?.nomination?.rejectionStatus === 2 &&
        props?.isApproveRejectionAllowed) ||
        (props?.nomination &&
          (props?.nomination?.status === 4 ||
            props?.nomination?.status === 6))) && (
        <div className="rejection-header">
          <div className="flex-col">
            <span
              className={Label() === "Verify Repair Completed" ? "repair" : ""}
            >
              {Label() === "Verify Repair Completed" ? (
                "✔"
              ) : (
                <SofIcon iconname="CircleRejection" />
              )}
            </span>
            <div className="heading-txt">
              <h3
                className={
                  Label() === "Verify Repair Completed" ? "repair" : ""
                }
              >
                {Label()}
              </h3>
              <p>
                Rejected Time
                <b>
                  &nbsp;
                  {moment
                    .utc(props?.nomination?.lastActivityDate)
                    .local()
                    .format("ll HH:mm")}
                </b>
              </p>
            </div>
          </div>
          <span
            onClick={() => {
              switch (modality) {
                case "TRUCK":
                  history.push({
                    pathname: `/${modality.toLowerCase()}/${nominationNo}/sof/rejection`,
                    state: { rejectionStatus: props?.nomination?.status },
                  });
                  break;
                case "RAIL":
                  history.push({
                    pathname: `/${modality.toLowerCase()}/${nominationNo}/sof/${
                      props?.nomination?.status === 6 ? "verify" : "confirm"
                    }/repair`,
                    state: { rejectionStatus: props?.nomination?.status },
                  });
                  break;
                default:
                  break;
              }
            }}
            className="forward"
          >
            <SofIcon iconname="Forward" />
          </span>
        </div>
      )}
      <div className={classes.buttonRow}>
        <div id="btn-nomination-no" className={classes.dropdown}>
          Nomination: <b>{toNominationNo(nominationNo)}</b>
        </div>
        {/* <span className={classes.buttonRowFiller} /> */}
        {view === NomView.View && (
          <div className="d-flex w-100" style={{ justifyContent: "end" }}>
            <button
              id="btn-nomination-comment"
              className={classes.button}
              disabled={props.isVerifyInformationModal || false}
              onClick={() => setView(NomView.Comments)}
            >
              <SofIcon iconname="Comment" />
              {/* &nbsp; Comments */}
            </button>
            {props.nomination &&
              props.isEditActivityAllowed &&
              isNominationEditable &&
              !props.isLineHandlingRejected && (
                <>
                  &nbsp;
                  <button
                    id="btn-edit-nomination"
                    className={classes.button}
                    disabled={props.isVerifyInformationModal || false}
                    onClick={() => setView(NomView.Edit)}
                  >
                    <SofIcon iconname="Edit" />
                    {/* &nbsp; Edit */}
                  </button>
                </>
              )}
          </div>
        )}

        {view === NomView.Comments && (
          <button
            className={classes.button}
            onClick={() => setView(NomView.View)}
          >
            <SofIcon iconname="Back" />
            &nbsp; Back
          </button>
        )}
      </div>
      {view === NomView.Comments && (
        <RemarksPane
          nominationNo={nominationNo}
          isAddCommentAllowed={props.isAddCommentAllowed}
          isDeleteCommentAllowed={props.isDeleteCommentAllowed}
          isOffline={props.isOffline}
          readonly={props.isApproved}
          onClose={() => setView(NomView.View)}
        />
      )}
      {view === NomView.View && props.nomination && (
        <NominationDetailsPane
          nomination={props.nomination}
          selTransferType={props.selTransferType}
        />
      )}

      {view === NomView.Edit && props.nomination && (
        <NominationForm
          {...props.nomination}
          lineHandlingStatus={props.lineHandlingStatus}
          onSuccess={(result: TruckNomination) => {
            setView(NomView.View);
            console.log(result, "result saved");
            props.setTruckNomination(result);
            props.onNominationEdit(result);
            props.onNominationEditEnd();
          }}
          onClose={() => {
            setView(NomView.View);
            props.onNominationEditEnd();
          }}
        />
      )}
    </>
  );
};

export default NominationPanel;
